import { Page } from './types'
import Todo from '../components/Todo'

type NotSupportedAPIProps = {
    api: string
}

const render = ({ api } : NotSupportedAPIProps) => {
    return <>
        <Todo>The {api} API is not supported yet in this tool</Todo>
    </>
}

const NotSupportedAPI : Page<NotSupportedAPIProps> = { key: 'not-supported-api', title: 'API not supported', render }

export default NotSupportedAPI